import { ProductType } from 'src/types/product-type';
import { createNormalizeChecking } from 'src/utils/create-normalize-checking';

export const checkProductType = createNormalizeChecking(
  (v) => `${v}`.trim() as ProductType,
  (v) => v in ProductType,
  'The productType parameter has an incorrect value. Please check it',
  ProductType.default
);
